
import React from "react";
import {
	Row,
	Col,
	Button,
	ButtonGroup
} from 'reactstrap';
import { authenticationService } from '../../jwt/_services';

import {
  G2Calibration,
	NovaCalibration
} from '../../components/calibration/';

class Calibration extends React.Component {

	intervalID = 0;

		constructor(props) {
    super(props);

			let currentUser = authenticationService.currentUserValue;
			if (!currentUser) {
				try {
					currentUser = JSON.parse(localStorage.getItem('currentUser'));
				} catch (err) {
					console.log("Unable to parse currentUser: " + err);
				}
			}
			let deviceList = [];
			try {
				deviceList = JSON.parse(localStorage.getItem('deviceList')) || [];
			} catch (err) {
				console.log("Unable to parse deviceList: " + err);
			}

			const querySerial = this.getQuerySerial();
			const role = this.getUserRoleFromCurrentUser(currentUser);
			const hasNovaDevice = this.hasNovaDeviceInList(deviceList);
			const querySerialIsNova = this.isNovaSerial(querySerial);
			const canShowNovaCalibration = role > 0 || hasNovaDevice;

	    this.state = {
				currentUser,
				deviceList,
	      calibrationType: querySerialIsNova && canShowNovaCalibration ? 1 : 0,
		  };

		//this.handleMessage = this.handleMessage.bind(this);
		//this.testCall = this.testCall.bind(this);
    this.onTabBtnClick = this.onTabBtnClick.bind(this);

  }

	componentDidMount() {

		//this.getData();
	}

	  async onTabBtnClick(calibrationTypeSelected) {
			this.setState({ calibrationType: calibrationTypeSelected });
		}

		getQuerySerial() {
			if (typeof window == "undefined") {
				return "";
			}

			const query = new URLSearchParams(window.location.search);
			return query.get("serial") || "";
		}

		getProduct(device) {
			return device.Product || device.product || device.ProductID || device.productID || device.productid || device.ProductId || device.productId;
		}

		isNovaSerial(serial) {
			return serial && String(serial).toUpperCase().startsWith("RJ");
		}

		hasNovaDeviceInList(deviceList) {
			return deviceList.some(device => {
				const product = this.getProduct(device);
				return product == 2 || this.isNovaSerial(device.SerialNumber);
			});
		}

		hasNovaDevice() {
			return this.hasNovaDeviceInList(this.state.deviceList);
		}

		getUserRoleFromCurrentUser(currentUser) {
			if (currentUser && currentUser.payload && currentUser.payload["custom:role"]) {
				return parseInt(currentUser.payload["custom:role"]);
			}

			if (currentUser && currentUser.role) {
				return parseInt(currentUser.role);
			}

			return 0;
		}

		getUserRole() {
			return this.getUserRoleFromCurrentUser(this.state.currentUser);
		}

		canShowNovaCalibration() {
			const role = this.getUserRole();
			return role > 0 || this.hasNovaDevice();
		}

	componentWillUnmount() {

	}

	getData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-devices";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all devices: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({ devices: body.results });
		} else {
      //ADD ERROR MESSAGE
    }

    //this.setState({ devicesLoaded: true });
	};


	render() {
		const showNovaCalibration = this.canShowNovaCalibration();

			return (
				<div>
	        <Row>
					<Col md="3">
					</Col>
          <Col md="6">
		          <div className="mt-1 mb-1 pb-4">
		            <ButtonGroup style={{ width: '100%' }}>
		              <Button
		                style={{width: '100%'}}
		                color="btngray"
		                onClick={() => this.onTabBtnClick(0)}
		                active={this.state.calibrationType === 0}
		              >
		                G2 Calibration
		              </Button>
									{showNovaCalibration &&
		              <Button
		                className="ml-1"
		                style={{width: '100%'}}
		                color="btngray"
		                onClick={() => this.onTabBtnClick(1)}
		                active={this.state.calibrationType === 1}
		              >
		                Nova Calibration
		              </Button>
									}
		            </ButtonGroup>
		          </div>
          </Col>
					<Col md="3">
					</Col>
        </Row>
        <Row>
						<Col md="12">
	            {this.state.calibrationType==0 &&
	              <G2Calibration />
	            }
							{this.state.calibrationType==1 && showNovaCalibration &&
	              <NovaCalibration />
	            }
					</Col>
				</Row>
			</div>
		);
	}
}

export default Calibration;
